"use client";

import React from "react";
import Link from "next/link";

import { Button } from "@shared/ui/button";
import { cn } from "@shared/ui/utils";

import { Logo } from "./logo";

const scrollToId = (id: string) => {
  const element = document.querySelector(id);
  if (element) {
    const headerOffset = 80; // Adjust for your fixed header
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: elementPosition - headerOffset, behavior: "smooth" });
  }
};
export const HeroHeader = () => {
  return (
    <header>
      <nav
        className={cn("fixed z-50 w-full transition-colors duration-150")}
        style={{ background: "rgba(0, 10, 21, 0.80)", backdropFilter: "blur(8px)" }}
      >
        <div
          className="absolute right-0 bottom-0 left-0 h-[1px] w-full"
          style={{
            background: "linear-gradient(to right, rgba(0,10,21,0), #1D232A, rgba(0,10,21,0))",
          }}
        />
        <div className="relative mx-auto flex max-w-5xl items-center justify-between px-6 py-3 transition-all duration-300 lg:gap-0 lg:py-4">
          <div className="flex w-full items-center justify-between gap-12 lg:w-auto">
            <Link href="/" aria-label="home" className="flex items-center space-x-2">
              <Logo />
            </Link>
          </div>

          <div>
            <Button size={"sm"}>
              <Link
                href="#join"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToId("#join");
                }}
              >
                <span>Join Waitlist</span>
              </Link>
            </Button>
          </div>
        </div>
      </nav>
    </header>
  );
};
